/**
 * The curated image library for campaign cards, shared by the dashboard
 * builder and the widget renderer.
 *
 * Preset scheme: instead of an http(s) URL, `content.image_url` may hold a
 * token of the form `preset:<name>` (e.g. `preset:dusk`). Renderers resolve
 * the token to a CSS gradient via `resolvePresetGradient` and paint a
 * gradient block where the image would go; an unknown preset name resolves
 * to `null` and renders no image. The backend whitelists the `preset:` form
 * alongside http(s) URLs in the content contract.
 */

export const CAMPAIGN_IMAGE_PRESETS = {
  sunrise: 'linear-gradient(135deg, #fbbf24 0%, #f97316 100%)',
  sunset: 'linear-gradient(135deg, #f97316 0%, #ec4899 100%)',
  ocean: 'linear-gradient(135deg, #0ea5e9 0%, #6366f1 100%)',
  meadow: 'linear-gradient(135deg, #22c55e 0%, #14b8a6 100%)',
  dusk: 'linear-gradient(135deg, #6e56cf 0%, #2563eb 100%)',
  blossom: 'linear-gradient(135deg, #ec4899 0%, #a855f7 100%)',
  ember: 'linear-gradient(135deg, #ef4444 0%, #f59e0b 100%)',
  midnight: 'linear-gradient(135deg, #1e293b 0%, #4338ca 100%)',
  slate: 'linear-gradient(135deg, #475569 0%, #94a3b8 100%)',
};

export const PRESET_IMAGE_PREFIX = 'preset:';

export const isPresetImage = url =>
  typeof url === 'string' && url.startsWith(PRESET_IMAGE_PREFIX);

export const resolvePresetGradient = url =>
  isPresetImage(url)
    ? (CAMPAIGN_IMAGE_PRESETS[url.slice(PRESET_IMAGE_PREFIX.length)] ?? null)
    : null;
